































import Vue from 'vue';
import { API } from '@/api';
import { mapActions, mapGetters } from 'vuex';

export default Vue.extend({
  data: () => ({
    openDialog: false,
    nuevaUnidad: {
      condominio: {
        direccion: '',
        id: 0,
        nombre: '',
        rfc: '',
      },
      ctaContable: '',
      id: null,
      creationUsername: '',
      creationDateTime: '',
      name: '',
    },
  }),
  methods: {
    modeloUnidad() {
      return {
        condominio: {
          direccion: '',
          id: 0,
          nombre: '',
          rfc: '',
        },
        ctaContable: '',
        id: null,
        creationUsername: '',
        creationDateTime: '',
        name: '',
      };
    },
    async AgregarSiguiente() {
      this.nuevaUnidad.creationUsername = this.$store.getters.getUsername;
      this.nuevaUnidad.creationDateTime = this.$moment().format();
      try {
        this.loading = true;
        const admin = this.$store.getters.getAdmin;
        const condo = this.$store.getters.getCondo;
        const condoUnidad = this.nuevaUnidad;
        condoUnidad.condominio = condo;
        const datos = {admin, condo, condoUnidad };
        console.debug('datos: %o', datos);
        const result = await this.$store.dispatch('addUnidad', datos );
        console.debug('respuesta: %o', result);
        this.$toast.success('Unidad agregada');
      } catch (e) {
        this.$toast.error(e.response.data.message);
      }
      this.nuevaUnidad.name = '';
      this.loading = false;
      this.modeloUnidad();
      this.$emit('reload', {});
    },
    async AgregarUnidad() {
      this.nuevaUnidad.creationUsername = this.$store.getters.getUsername;
      this.nuevaUnidad.creationDateTime = this.$moment().format();
      try {
        this.loading = true;
        const admin = this.$store.getters.getAdmin;
        const condo = this.$store.getters.getCondo;
        const condoUnidad = this.nuevaUnidad;
        condoUnidad.condominio = condo;
        const datos = {admin, condo, condoUnidad };
        console.debug('datos: %o', datos);
        const result = await this.$store.dispatch('addUnidad', datos );
        console.debug('respuesta: %o', result);
        this.$toast.success('Unidad agregada');
      } catch (e) {
        this.$toast.error(e.response.data.message);
      }
      this.loading = false;
      this.openDialog = false;
      this.$emit('reload', {});
    },
  },
  watch: {
    openDialog() {
      if (!this.openDialog) {
        this.nuevaUnidad = this.modeloUnidad();
      }
    },
  },
});
